import React, { useState, useEffect, useRef } from 'react';
import { deleteComment, addComment, getComments } from 'src/store/comment';
import { useDispatch, useSelector } from "react-redux";
import { format } from "date-fns";
import { ValidationMessages } from 'src/components/common/ValidationMessage';

const CommentPopup = ({ isOpen, togglePopup, dailyWorkId, loginUserID, dailyMemo }) => {

    const comments = useSelector((state) => state.comment.allData.comment_list);
    const [commentText, setCommentText] = useState('');
    const [validationMessages, setValidationMessages] = useState([]);
    const [refresh, setRefresh] = useState('');
    const dispatch = useDispatch();
    const commentsListRef = useRef(null);
    const handleCommentChange = (e) => {
        setCommentText(e.target.value);
    };

    useEffect(() => {
        dispatch(getComments(dailyWorkId))
        .then((res) => {
            if (res.error) {
                setValidationMessages(res.error.message);
            }
        })
        .catch((error) => {
            setValidationMessages([error.message]);
        });
    }, [dailyWorkId, refresh]);

    useEffect(() => {
        if (isOpen && commentsListRef.current) {
            commentsListRef.current.scrollTop = commentsListRef.current.scrollHeight;
        }
    }, [isOpen, comments]);

    const addCmnts = {
        daily_memo_comment: commentText,
        t_daily_work_id: +dailyWorkId,
        t_user_id: +loginUserID,
    }

    if (!isOpen) return null

    const handleSubmit = (e) => {
        e.preventDefault();
        if (!commentText) return;
        dispatch(addComment(addCmnts))
            .then((response) => {
                if(response.payload?.errors) {
                    alert(response.payload.errors)
                }
                setCommentText(''); // Reset after submit
                setRefresh(response);
            })
            .catch((error) => {
                alert('Error Adding comment:', error);
            });
    };

    const onDeleteComment = (commentId) => {
        dispatch(deleteComment(commentId))
            .then((response) => {
                if(response.payload?.errors) {
                    alert(response.payload.errors)
                }
                setRefresh(response);
            })
            .catch((error) => {
                alert('Error deleting comment:', error);
            });
    };


    return (
        <div className="notice-area notice-popup">
            <div className="popup-close jq-mame-popup-close" onClick={togglePopup}>
                <span className="glyphicon glyphicon-remove" aria-hidden="true"></span>
            </div>

            <div className="layout-popup popup_area" style={{ top: '10%' }}>
                <div className="mamemo-area">
                    <p className="comment_pop_mamemo">
                        {dailyMemo}
                    </p>
                </div>
                {validationMessages && validationMessages.length > 0 && (
                    <div style={{ background: "#ffe4e2" }}>
                        <ValidationMessages
                            messages={validationMessages}
                            onClose={() => setValidationMessages([])}
                        />
                    </div>
                )}

                {comments?.daily_work_details?.comment_list?.length > 0 && (
                    <div className="comment_list" ref={commentsListRef} style={{ scrollbarWidth: 'thin' }}>
                        {comments?.daily_work_details?.comment_list?.map((comment) => (
                            <div
                                key={comment.id}
                                style={{
                                    marginBottom: '10px',
                                    ...(loginUserID === comment.t_user_id
                                        && { textAlign: 'right', marginRight: '25px' }),
                                }}
                            >
                                {loginUserID !== comment.t_user_id ? (
                                    <>
                                        <div className="comment_icon_style" style={{ marginRight: '1px' }}>
                                            <span
                                                className={`statusicon sta-icon${comment.icon_num} holiday_mark`}
                                            ></span>
                                            <p className="comment_username">{comment.user_name}</p>
                                        </div>
                                        <div style={{ display: 'inline-block', width: '80%' }}>
                                            <span className="comment_balloonA">
                                                <span>{comment.daily_memo_comment}</span>
                                            </span>
                                            <div>
                                                <span style={{ marginLeft: '10px' }}>
                                                    {format((new Date(comment.ins_datetime)), "yyyy/MM/dd hh:mm")}
                                                </span>
                                            </div>
                                        </div>
                                    </>
                                ) : (
                                    <>
                                        <div style={{ display: 'inline-block', width: '80%' }}>
                                            <span className="comment_balloonB my_comment">
                                                <span>{comment.daily_memo_comment}</span>
                                            </span>
                                            <div>
                                                <span style={{ marginRight: '10px' }}>
                                                    {format((new Date(comment.ins_datetime)), "yyyy/MM/dd hh:mm")}
                                                </span>
                                                <button
                                                    style={{ color: '#C33', border: 'none', background: 'none' }}
                                                    onClick={() => onDeleteComment(comment.id)}
                                                >
                                                    Delete
                                                </button>
                                            </div>
                                        </div>
                                        <div className="comment_icon_style">
                                            <span
                                                className={`statusicon sta-icon${comment.icon_num} holiday_mark`}
                                            ></span>
                                            <p className="comment_username">{comment.user_name}</p>
                                        </div>
                                    </>
                                )}
                            </div>
                        ))}
                    </div>
                )}

                <form className="form-horizontal" id="comment_form" onSubmit={handleSubmit}>
                    <div className="form-group">
                        <div className="col-sm-9 comment_form" style={{ width: '100%', display: 'flex', alignItems: 'center', gap: '10px' }}>
                            <input type="hidden" name="daily_work_id" />
                            <textarea
                                className="form-control comment_text"
                                name="daily_work_comment"
                                value={commentText}
                                onChange={handleCommentChange}
                                style={{ resize: 'vertical', height: '50px' }}
                            ></textarea>
                            <button type="submit" className="btn btn-success btn-sm jq-comment-btn" style={{ marginTop: '10px' }}>
                                Send
                            </button>
                        </div>
                    </div>
                </form>
            </div>
        </div>
    );
};

export default CommentPopup;
